module.exports = __webpack_public_path__ + "static/media/ckn_reporte_datos.c816d8a8.jpg";